
/* Includes js theme Wheeler */

import './components/mainsite';

import './components/testimonialSlider.js';

import './components/messages-inline.js';

/* dashboard agronet */
import './dashboard/main.js';
import './dashboard/formulario.js';
import './dashboard/filter-modal.js';
import './dashboard/notifications-mail.js';

import './components/secop-main-internal.js';
